export default [
  {
    reducerKey: 'referrals/list',
    sagaKey: 'referralsListSaga',
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-referral" */ 'modules/Referrals/ReferralsList/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-referral" */ 'modules/Referrals/ReferralsList/store/saga'
      ),
  },
  {
    reducerKey: 'referral/links',
    sagaKey: 'referralLinksSaga',
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-referral" */ 'modules/Referrals/ReferralLinks/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-referral" */ 'modules/Referrals/ReferralLinks/store/saga'
      ),
  },
  {
    reducerKey: 'referral/clients',
    sagaKey: 'referralClientsSaga',
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-referral" */ 'modules/Referrals/ReferralClients/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-referral" */ 'modules/Referrals/ReferralClients/store/saga'
      ),
  },
  {
    reducerKey: 'referrals/payout-profiles-list',
    sagaKey: 'referralsPayoutProfilesListSaga',
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-referral" */ 'modules/Referrals/PayoutProfiles/List/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-referral" */ 'modules/Referrals/PayoutProfiles/List/store/saga'
      ),
  },
  {
    reducerKey: 'referrals/payout-profiles-invoices',
    sagaKey: 'referralsPayoutProfilesInvoicesSaga',
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-referral" */ 'modules/Referrals/PayoutProfiles/Invoices/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-referral" */ 'modules/Referrals/PayoutProfiles/Invoices/store/saga'
      ),
  },
]
